import { Routes } from '@angular/router';
import { authGuard } from '@lib/guards';

export const routes: Routes = [
    {
        path: '',
        loadChildren: async () => (await import('@pages/index')).routes,
    },
    {
        path: 'auth',
        loadChildren: async () => (await import('@pages/auth')).routes,
        canMatch: [authGuard({ requiresAuthentication: false })],
    },
    {
        path: 'certificate/:id',
        title: 'Certificate Verification - IITB Educational Outreach',
        loadComponent: async () =>
            (await import('./pages/view-certificate/view-certificate.component')).ViewCertificateComponent,
        canMatch: [authGuard({ requiresAuthentication: false })],
    },
    {
        path: '**',
        loadComponent: async () => (await import('@pages/screens/not-found/not-found.component')).NotFoundComponent,
    },
];
